import { call, put } from 'redux-saga/effects';
import { assignAdvancedUserRight } from '../api';
import {
  assignAdvancedUserRightSuccess,
  assignAdvancedUserRightFailure,
} from '../actions';
import { AssignAdvancedUserRightRequestAction } from '../types';

export function* assignAdvancedUserRightSaga(
  action: AssignAdvancedUserRightRequestAction
): Generator {
  try {
    const { accountId, organisationId, operationIds } = action.payload;
    yield call(
      assignAdvancedUserRight,
      accountId,
      organisationId,
      operationIds
    );
    yield put(assignAdvancedUserRightSuccess());
  } catch (error) {
    yield put(assignAdvancedUserRightFailure());
  }
}
